import createVueApp from '@phoenix/createVueApp';
import { PhxScrollSequence } from '@phx-styleguides/jlc';

document.querySelectorAll('.phoenix-scroll-sequence').forEach((el) => {
  const app = createVueApp();
  app.component('PhxScrollSequence', PhxScrollSequence);
  app.mount(el);
});
